import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-[#FCFCFB] text-[#5A5B5C]"
        data-testid="protected-loading"
      >
        <div className="flex items-center gap-3">
          <div className="h-5 w-5 rounded-full border-2 border-[#A7B584] border-t-transparent animate-spin" />
          <span className="text-sm">Sitzung wird geprüft…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
